export type PeriodConfig =
  | { type: 'live' }
  | { type: 'period'; days: '7d' | '14d' | '30d' | '90d' }
  | { type: 'custom'; from: string; to: string };

export type ActiveTab =
  | 'home' | 'overview' | 'realtime' | 'users' | 'videos' | 'engagement'
  | 'topUsers' | 'geography' | 'aiLens' | 'devices' | 'scans'
  | 'subscriptions' | 'revenue' | 'userJourney' | 'userSegments' | 'leaderboard'
  | 'countryAnalysis' | 'adsRoi' | 'database';

export interface TabConfig {
  key: ActiveTab;
  label: string;
}

export const TABS: TabConfig[] = [
  { key: 'home', label: 'Home' },
  { key: 'overview', label: 'Overview' },
  { key: 'realtime', label: 'Realtime' },
  { key: 'users', label: 'Users' },
  { key: 'videos', label: 'Videos' },
  { key: 'engagement', label: 'Engagement' },
  { key: 'topUsers', label: 'Top Users' },
  { key: 'geography', label: 'Geography' },
  { key: 'aiLens', label: 'AI Lens' },
  { key: 'devices', label: 'Devices' },
  { key: 'scans', label: 'Scans' },
  { key: 'subscriptions', label: 'Sub Funnel' },
  { key: 'revenue', label: 'Revenue' },
  { key: 'userJourney', label: 'User Journey' },
  { key: 'userSegments', label: 'Deep Segments' },
  { key: 'leaderboard', label: 'Leaderboard' },
  { key: 'countryAnalysis', label: 'Country ROI' },
  { key: 'adsRoi', label: 'Ads ROI' },
  { key: 'database', label: 'Database' },
];

export const BRAND_GRADIENT = 'from-[#FF9C15] to-[#F42026]';
export const COLORS = ['#FF9C15', '#F42026', '#ff6b35', '#fbbf24', '#fb923c', '#f97316', '#ef4444', '#dc2626', '#c084fc', '#38bdf8', '#34d399', '#a78bfa'];

export const formatNumber = (n: number): string => {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(1) + 'K';
  return n.toLocaleString();
};

export const formatDate = (dateStr: string): string => {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const formatMonth = (year: number, month: number): string => {
  const d = new Date(year, month - 1);
  return d.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
};

export const tooltipStyle = {
  background: 'rgba(15, 23, 42, 0.95)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: '12px',
  color: '#fff',
};
